import { useSettings } from './usePublicContent';

export function useCurrency() {
  const { data: settings } = useSettings();
  const symbol = settings?.currency?.symbol ?? '$';

  return {
    symbol,
    format: (amount: number | string) => `${symbol}${Number(amount).toFixed(2)}`,
  };
}
